(function() { window.GUID_f3345a9f_0bc6_4c82_a1fa_85da52970739 = { getGuid: function() { return "f3345a9f-0bc6-4c82-a1fa-85da52970739"; } }; })();
var CS;
(function (CS) {
    var Cookie;
    (function (Cookie) {
        function GetCookie(cookieName) {
            return $.cookie("CSCookie." + cookieName);
        }
        Cookie.GetCookie = GetCookie;
        function SetCookie(cookieName, value, expires) {
            if (!CS.CookieConsent.CanUseFunctionalPreferences()) {
                console.debug("CS.Cookie.SetCookie skipped because functional app preferences have not been accepted.", { cookieName });
                return;
            }
            $.removeCookie("CSCookie." + cookieName);
            if (!expires)
                expires = 365;
            $.cookie("CSCookie." + cookieName, value, { expires, path: "/" });
        }
        Cookie.SetCookie = SetCookie;
        function RemoveCookie(cookieName) {
            $.removeCookie("CSCookie." + cookieName);
        }
        Cookie.RemoveCookie = RemoveCookie;
    })(Cookie = CS.Cookie || (CS.Cookie = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-cookie.js.map
